import { ChangeDetectionStrategy, Component } from '@angular/core'

import { Confirmable } from '@app/modules/ui/models/confirmable'
import { UIModule } from '@app/modules/ui/ui.module'

@Component({
  selector: 'sb-voice-message-boost-insufficient-credits-modal',
  templateUrl: './voice-message-boost-insufficient-credits-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessageBoostInsufficientCreditsModalComponent extends Confirmable {}
